import { createClient } from "@supabase/supabase-js";
import { env } from "./env";
import type { Database } from "./database.generated";

// Typed Supabase client. The generic `<Database>` wires PostgREST responses
// to the auto-generated schema in `database.generated.ts`, so .from('foo')
// .select() now infers row types. Regenerate the types file after schema
// changes (see header comment in database.generated.ts).
//
// For domain-level types with semantics (e.g. WLIntakeResponses on the jsonb
// `responses` column), import from `database.types.ts` instead.
export const supabase = createClient<Database>(
  env.VITE_SUPABASE_URL,
  env.VITE_SUPABASE_PUBLISHABLE_KEY,
  {
    auth: {
      persistSession: true,
      autoRefreshToken: true,
      detectSessionInUrl: true,
      flowType: "pkce",
    },
  },
);
